import { usePaymentManager } from "../../contexts/PaymentManagerContext";
import AuthorizePaymentGateway from "../../gateways/AuthorizePaymentGateway/AuthorizePaymentGateway";
import StripePaymentGateway from "../../gateways/StripePaymentGateway/StripePaymentGateway";
import YunoPaymentGateway from "../../gateways/YunoPaymentGateway/YunoPaymentGateway";
import StripeCardElement from "../../stripe/StripeCardElement/StripeCardElement.web";
import YunoCardElement from "../yuno/YunoCardElement/YunoCardElement.web";
import AuthorizeCardElement from "../authorize/AuthorizeCardElement/AuthorizeCardElement.web";
import { CardElementSharedProps } from "./CardElement.props";

/**
 * Dynamically displays a component for manual card entry, depending on the Payment Gateway selected
 * by the Payments Orchestration system
 *
 * Requires the PaymentManagerContext.
 */
function CardElement(props: CardElementSharedProps) {
  const { manager } = usePaymentManager();

  if (!manager.handler?.gateway) {
    return null;
  }

  if (manager.handler.gateway instanceof StripePaymentGateway) {
    return <StripeCardElement {...props} />;
  }

  if (manager.handler.gateway instanceof AuthorizePaymentGateway) {
    return <AuthorizeCardElement {...props} />;
  }

  if (manager.handler.gateway instanceof YunoPaymentGateway) {
    return <YunoCardElement {...props} />;
  }

  return null;
}

export default CardElement;
